export default __webpack_public_path__ + "static/media/cloud3.195a00c6.png";